import { render } from "./DeliveryPlatformsTab.vue?vue&type=template&id=3064ff83"
import script from "./DeliveryPlatformsTab.vue?vue&type=script&lang=js"
export * from "./DeliveryPlatformsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__